import { FormControl } from '@chakra-ui/react';
import { useAppDispatch } from '../../../../store/redux/hooks';
import { useRef } from 'react';
import AddonInput from '../AddonInput';
import FieldEditIndicator from '../FieldEditIndicator';
import { useFieldEditIndicator } from '../hooks/useFieldEditIndicator';
import { NotificationMessage as NotificationMessageType } from '../../../../store/types/template';
import {
  setNotificationMessageProp,
  setFocusedField,
} from '../../../../store/redux/slices/template.slice';

const NotificationMessage = ({
  message,
  index,
}: {
  message: NotificationMessageType;
  index: number;
}) => {
  const dispatch = useAppDispatch();
  const messageRef = useRef<HTMLDivElement>(null);
  const fieldPath = `notificationMessages.${index}.label`;
  const { activeFieldRef, isFieldBeingEdited } = useFieldEditIndicator({
    fieldRefMap: {
      [fieldPath]: messageRef,
    },
  });

  return (
    <FieldEditIndicator
      fieldRef={messageRef}
      isFieldBeingEdited={isFieldBeingEdited}
      activeFieldRef={activeFieldRef}
      left="-55px"
      top="25px"
    >
      <FormControl mt={4}>
        <AddonInput
          label={
            index === 0 ? 'Unstamped' : `${index} Stamp${index > 1 ? 's' : ''}`
          }
          placeholder={`${index === 1 ? 'e.g. You’ve just earned your first stamp!' : ''}`}
          value={message.label || ''}
          onChange={(value) =>
            dispatch(
              setNotificationMessageProp({ index, field: 'label', value })
            )
          }
          onFocus={() => dispatch(setFocusedField(fieldPath))}
          onBlur={() => dispatch(setFocusedField(null))}
        />
      </FormControl>
    </FieldEditIndicator>
  );
};

export default NotificationMessage;
